import { render, staticRenderFns } from "./items-list-tab.vue?vue&type=template&id=4c5f7d39&"
import script from "./items-list-tab.vue?vue&type=script&lang=js&"
export * from "./items-list-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports